import { createFileRoute } from '@tanstack/react-router';

import { VisitorsPage } from '@/features/siteplan/visitors-page';

export const Route = createFileRoute('/_app/projects/$projectId/site/visitors')({
  component: PageRoute,
});

function PageRoute() {
  const { projectId } = Route.useParams();
  return <VisitorsPage projectId={projectId} />;
}
